import React, { useEffect } from 'react';
import { Tag } from 'antd';
import { AlertTriangle } from 'react-feather';
import { useLicensesQuery } from '../asset/services/queries';

type Props = {
  module: string;
  dataSource: any[] | undefined;
};

export default function LicenseBadge({
  module,
  dataSource,
  children,
}: React.PropsWithChildren<Props>) {
  const { data: license, isFetching, refetch } = useLicensesQuery();

  const licenseArgs: any = (license && license[module]) || {};

  useEffect(() => {
    if (!isFetching && dataSource) refetch();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dataSource]);

  const { total, limit } = licenseArgs;
  const warning = limit !== null ? limit === 'None' || total >= limit : false;
  if (limit === 0 || !limit) return <>{children}</>;
  return (
    <>
      <Tag className="h-8 text-base/8">
        {warning ? <AlertTriangle size={20} className="mr-2 mb-1" /> : null}
        {`${total} / ${limit === 'None' ? 0 : limit}`}
      </Tag>
      {warning ? null : children}
    </>
  );
}
